import TestFilterTabs from '../generic/TestFilterTabs';
import DifficultySummary from './DifficultySummary';
import DifficultyTestBreakdown from './DifficultyTestBreakdown';
import { useState, useEffect, useRef } from 'react';
import { useDifficultyAnalysis } from './hooks/useDifficultyAnalysis';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';
import PackPagination from '../generic/PackPagination';
import PackButton from '../generic/PackButton';

const DifficultyAnalysis = ({ packId, onResetFilters }) => {
  const [activeFilter, setActiveFilter] = useState('all');
  const { data, loading, error, page, setPage } = useDifficultyAnalysis(packId, activeFilter);
  // assuming your custom hook can expose `page` & `setPage`
  const navigate = useNavigate();

  const breadcrumbItems = ['JEE Main Test series', 'Pack Analysis', 'Difficulty Analysis'];

  // Scroll states for hide-on-scroll behavior
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isDescriptionVisible, setIsDescriptionVisible] = useState(true);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!scrollContainerRef.current) return;
      const currentScrollY = scrollContainerRef.current.scrollTop;
      const isTabletOrBelow = window.innerWidth < 1024; // lg breakpoint

      if (!isTabletOrBelow) {
        if (currentScrollY <= 0) {
          if (!isDescriptionVisible) setIsDescriptionVisible(true);
        } else if (currentScrollY > 70 && isDescriptionVisible) {
          setIsDescriptionVisible(false);
        } else if (currentScrollY < 30 && !isDescriptionVisible) {
          setIsDescriptionVisible(true);
        }
        setIsHeaderVisible(true);
        return;
      }

      if (currentScrollY < lastScrollY) {
        setIsHeaderVisible(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsHeaderVisible(false);
      }
      setLastScrollY(currentScrollY);
    };

    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll, { passive: true });
      return () => scrollContainer.removeEventListener('scroll', handleScroll);
    }
  }, [lastScrollY]);

  return (
    <div className="w-full max-w-4xl mx-auto flex flex-col h-screen overflow-y-auto" ref={scrollContainerRef}>
      {/* Sticky Header */}
      <div
        className={`z-10 q3-glass rounded transition-transform duration-300 ease-in-out lg:transform-none ${
          isHeaderVisible ? 'translate-y-0' : '-translate-y-full'
        }`}
      >
        <div className="p-6 pb-4">
          {/* Mobile Back Button */}
          <PackButton navigateTo="/v2/home" />

          <div className="mb-6">
            <h1 className="text-3xl font-bold text-[var(--q3-neutral-default)] mb-2">Difficulty Analysis</h1>
          </div>

          {/* <TestFilterTabs activeFilter={activeFilter} onFilterChange={setActiveFilter} /> */}
        </div>
      </div>

      {/* Scrollable Content */}
      <div className="p-6 pt-2 space-y-8">
        <DifficultySummary data={data?.summary} loading={loading} error={error} onResetFilters={onResetFilters} />

        <DifficultyTestBreakdown
          data={data?.difficultyAnalysis}
          loading={loading}
          error={error}
          packId={packId}
          onResetFilters={onResetFilters}
        />

        {/* Pagination (same as Performance) */}
        {data?.totalPagesAvailable > 1 && (
          <PackPagination
            totalPages={data?.totalPagesAvailable}
            activePage={page}
            onPageClick={(newPage) => setPage(newPage)}
          />
        )}
      </div>
    </div>
  );
};

export default DifficultyAnalysis;
